import { render, staticRenderFns } from "./conteudo-beneficios.vue?vue&type=template&id=5479951f"
import script from "./conteudo-beneficios.vue?vue&type=script&lang=js"
export * from "./conteudo-beneficios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports